import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-hierarchie-modif-modal',
  templateUrl: './hierarchie-modif-modal.component.html',
  styleUrls: ['./hierarchie-modif-modal.component.scss'],
})
export class HierarchieModifModalComponent implements OnInit {
  showAddParent = false;
  showAddChild = false;
  newChild = '';
  newParent = '';
  unsavedChanges = false;
  constructor(
    public generalService: GeneralService,
    public dialogRef: MatDialogRef<HierarchieModifModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public node: { Name: string; Parent: Array<string>; childs: Array<string> }
  ) {}

  ngOnInit(): void {}
  submit() {
    if (this.showAddChild) this.node.childs.unshift(this.newChild);
    if (this.showAddParent) this.node.Parent.unshift(this.newParent);

    this.newChild = '';
    this.newParent = '';
    this.showAddParent = false;
    this.showAddChild = false;
    this.unsavedChanges = true;
  }
  close() {
    this.dialogRef.close(this.node);
    this.unsavedChanges = false;
  }
}
